import { AllSelectOption } from '@storage/app/models'

export const mapOptionalFieldValueToString = <T>(value: AllSelectOption | T): T | undefined => {
  return value === 'All' ? undefined : value
}
